export const convertToDate = (value?: Date) => {
    return value ? new Date(value) : new Date();
}
